import { Annotation, AttachmentDetails, EvidenceSessionAIModel } from 'api';

export const MaterialForm = { baled: 'baled', briquette: 'briquette', loose: 'loose' } as const;
export type MaterialForm = keyof typeof MaterialForm;

export interface PreviewGalleryImage {
  src: string;
  feedbackMessages?: string[];
  status?: 'uploading' | 'offline' | 'success' | 'warning' | 'success-warning';
  id?: string;
  message?: string;
  disableDelete?: boolean;
  attachmentDetails?: AttachmentDetails | null;
  targetWeightPercentage?: number | null;
  aiModel?: EvidenceSessionAIModel;
  annotations?: Annotation[];
}
